import OnewayPickupBasicRate from "pages/OnewaypickupBasicRate";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import CityServices from "services/CityServices";

const OnewayPickupSelectCity = ({
  register,
  selectedCity,
  handleCityChange,
  name,
  label,
  readonly,
}) => {
 
  const [Cities, setCities] = useState([]);
  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      border: "1px",
      boxShadow: "none",
      backgroundColor: "RRGGBB",
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isSelected
        ? "#0e9f6e"
        : state.isFocused
          ? "rgba(0, 0, 0, 0.15)"
          : "white",
      color: state.isSelected ? "white" : state.onClick ? "green" : "black",
      "&:hover": {
        background: "rgba(0, 0, 0, 0.15)", // Change the background color on hover
        color: "black", // Change the text color on hover
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      margin: "10px 0 -10px 0", // Add margin to the entire option box
    }),
    indicatorSeparator: () => ({
      display: "none", // Removes the separator line
    }),
  };
  useEffect(() => {
    let isMounted = true; // Add this variable to track the component's mounting state

    async function fetchcity() {
      try {
        const response = await CityServices.getAllCity();
      
        const transformedData = response.data.map((item) => ({
          value: item.id_city,
          label: item.name,
        }));

        // Check if the component is still mounted before updating the state
        if (isMounted) {
          setCities(transformedData);
        }
      } catch (error) {
        console.error("Error fetching city:", error);
      }
    }

    fetchcity();

    // Cleanup function to set isMounted to false when the component is unmounted
    return () => {
      isMounted = false;
    };
  }, []);

const handleCitySelect = async (selected) => {
  if (!selected) return;

  const item = Cities.find((item) => item.value === selected.value);

  if (item && typeof handleCityChange === "function") {
    handleCityChange(selected.value);
  }
};

 return (
  <>
    {/* THIS is the missing bridge */}
    <input
      type="hidden"
      name={name}
      value={selectedCity || ""}
      {...register(name, {
        required: !selectedCity ? `${label} is required!` : false,
      })}
    />

    <Select
      className="py-1 dark:text-white-300 leading-5 rounded-md dark:focus:ring-gray-300 dark:bg-gray-700 border h-12 text-sm focus:outline-none block w-full bg-white-100 border-transparent focus:bg-white"
      styles={customSelectStyles}
      options={Cities}
      isDisabled={readonly}
      onChange={(e) => handleCitySelect(e)}
      value={
        selectedCity
          ? Cities.find(
              (option) => String(option.value) === String(selectedCity)
            )
          : null
      }
    />
  </>
);

};

export default OnewayPickupSelectCity;
